(() => {
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init() {
    document.querySelectorAll('[data-studio-videos]').forEach(container => {
      if (instances.has(container)) return;
      const abort = new AbortController();
      const options = {signal: abort.signal};
      const states = [];
      const auto = () => container.dataset.autoplay === 'true' && !reduced.matches;
      const noSound = container.dataset.noSound === 'true';
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = states.find(s => s.video === entry.target);
          state.visible = entry.isIntersecting && entry.intersectionRatio >= .5;
          update(state);
        });
      }, {threshold: [0,.5]});
      function play(state) { state.video.play().catch(() => {}); }
      function update(state) {
        if (document.hidden || !state.visible) state.video.pause();
        else if (auto() && !state.userPaused) play(state);
      }
      container.querySelectorAll('.studio-video-item').forEach(item => {
        const video = item.querySelector('video');
        const button = item.querySelector('[data-video-play]');
        const sound = item.querySelector('[data-video-sound]');
        const state = {video, visible:false, userPaused:false};
        states.push(state);
        video.controls = false;
        video.muted = true;
        button.hidden = false;
        sound.hidden = noSound || (auto() && container.dataset.showSound !== 'true');
        button.addEventListener('click', () => {
          state.userPaused = !video.paused;
          if (video.paused) play(state); else video.pause();
        }, options);
        const sync = () => {
          button.textContent = video.paused ? '▶' : 'Ⅱ';
          button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        };
        video.addEventListener('play', sync, options);
        video.addEventListener('pause', sync, options);
        sound.addEventListener('click', () => {
          video.muted = !video.muted;
          sound.textContent = video.muted ? '♪' : '♫';
          sound.setAttribute('aria-label', video.muted ? 'Turn on sound' : 'Mute video');
          sound.setAttribute('aria-pressed', String(!video.muted));
        }, options);
        observer.observe(video);
      });
      const refresh = () => states.forEach(update);
      document.addEventListener('visibilitychange', refresh, options);
      reduced.addEventListener('change', () => {states.forEach(s=>s.video.pause());refresh();}, options);
      instances.set(container, () => {states.forEach(s=>s.video.pause());observer.disconnect();abort.abort();});
    });
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    for (const [container, cleanup] of instances) if(event.target.contains(container)){cleanup();instances.delete(container);}
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
